import config from 'config'
import CoinsDropIcon from 'assets/images/icons/coins_drop.svg'
import CoinsIcon from 'assets/images/icons/coins.svg'
import CalendarIcon from 'assets/images/icons/calendar.svg'
import PercentIcon from 'assets/images/icons/percent.svg'
import BankIcon from 'assets/images/icons/bank.svg'
import {
  PAYMENT_TYPE_MORE_SURCHARGE,
  PAYMENT_TYPE_MORE_BOOK_LATER,
  PAYMENT_TYPE_LESS_PARTIAL,
  PAYMENT_TYPE_LESS_DISCOUNT,
  PAYMENT_TYPE_LESS_BANKCHARGE,
} from 'payment/constants'

const resourceUrl = `${config.resourceHost}payment`

export const createAddPaymentForInvoiceUrl = (id) => `${config.resourceHost}invoice/${id}/payment`
export const createAddPaymentForCreditNoteUrl = (id) => `${config.resourceHost}creditnote/${id}/payment`
export const createAddPaymentForExpenseUrl = (id) => `${config.resourceHost}expense/${id}/payment`
export const createAddPaymentForRevenueUrl = (id) => `${config.resourceHost}revenue/${id}/payment`

export default {
  resourceUrl,
  global: config,

  createAddPaymentForInvoiceUrl,
  createAddPaymentForCreditNoteUrl,
  createAddPaymentForExpenseUrl,
  createAddPaymentForRevenueUrl,

  surplusOptions: [
    {
      icon: CoinsDropIcon,
      title: 'Als Zuschlag behandeln',
      description: 'Nicht weiter verbuchen',
      value: PAYMENT_TYPE_MORE_SURCHARGE,
    },
    {
      icon: CalendarIcon,
      title: 'Restbetrag später verbuchen',
      description: 'Restbetrag kann später zugeordnet werden',
      value: PAYMENT_TYPE_MORE_BOOK_LATER,
    },
  ],
  deficitOptions: [
    {
      icon: CoinsIcon,
      title: 'Als Teilzahlung behandeln',
      description: 'Rechnungsstatus: teilweise bezahlt',
      value: PAYMENT_TYPE_LESS_PARTIAL,
    },
    {
      icon: PercentIcon,
      title: 'Als Skonto behandeln',
      description: 'Rechnungsstatus: vollständig bezahlt',
      value: PAYMENT_TYPE_LESS_DISCOUNT,
    },
    {
      icon: BankIcon,
      title: 'Als Bankgebühr behandeln',
      description: 'Rechnungsstatus: vollständig bezahlt',
      value: PAYMENT_TYPE_LESS_BANKCHARGE,
    },
  ],
}
